<template>
  <div :class="classes()">
    <Headline size="m" isViewHeadline>{{ $t('mainNav.item.taskScheduler') }}</Headline>
    <IntroBanner
      :headline="$t('taskScheduler.infoBanner.headline')"
      :copy="$t('taskScheduler.infoBanner.copy')"
      :list="$t('taskScheduler.infoBanner.list')"
      :bottomSpace="40"
      :localStorage="LS_TASK_SCHEDULER_INFO_BANNER"
    />

    <TaskGoals :class="`${el}__taskGoals`" :variant="taskGoalsVariant" background="light" />
    <div :class="`${el}__tasks`">
      <InViewAnimation>
        <Copy :slot="1" element="div" :staticClass="`${el}__tasksHeadline`" size="l" bold>
          {{ $t('taskScheduler.tasks.headline') }}
        </Copy>
      </InViewAnimation>

      <InViewAnimation v-if="relevantTasksAreDone && !allTasksAreDone" :delay="1">
        <div :slot="1" :class="`${el}__done`">
          <Copy element="div" size="l" color="primaryBlue" bold centered>
            {{ $t('taskScheduler.done.headline') }}
          </Copy>
          <Copy element="div" size="l" color="tertiaryLight" centered>
            {{ $t('taskScheduler.done.subline.relevantTasks') }}
          </Copy>
        </div>
      </InViewAnimation>

      <InViewAnimation v-if="allTasksAreDone" :delay="1">
        <div :slot="1" :class="`${el}__done`">
          <Copy element="div" size="l" color="primaryBlue" bold centered>
            {{ $t('taskScheduler.done.headline') }}
          </Copy>
          <Copy element="div" size="l" color="tertiaryLight" centered>
            {{ $t('taskScheduler.done.subline.allTasks') }}
          </Copy>
        </div>
      </InViewAnimation>

      <template v-else>
        <InViewAnimation :delay="1">
          <Tasks
            v-for="(item, idx) in relevantTasks"
            :slot="idx + 1"
            :key="`task-${item.taskId}`"
            :task="item"
            :isCollapsible="!!item.subTasks"
            :current="idx === 0"
            :collapsibleIsOpen="idx === 0"
            :hide="item.checked"
          />
        </InViewAnimation>

        <InViewAnimation v-if="hasOptionalTasks" :delay="relevantTasks.length + 1">
          <Copy :slot="1" element="div" :staticClass="`${el}__optionalTasksHeadline`" size="l" bold>
            {{ $t('taskScheduler.tasks.optional.headline') }}
          </Copy>
        </InViewAnimation>

        <InViewAnimation :delay="relevantTasks.length + 2">
          <Tasks
            v-for="(item, idx) in optionalTasks"
            :key="`task-${item.taskId}`"
            :slot="idx + 1"
            :task="item"
            :isCollapsible="!!item.subTasks"
            :hide="item.checked"
            isOptionalTask
          />
        </InViewAnimation>
      </template>
    </div>

    <template v-if="testing">
      <div class="u-margin__vertical--5" />
      <Copy size="l" bold>Debugging:</Copy>
      <Button label="Aufgaben zurücksetzen" @click="__resetTasks" small />
      <pre>Aktuelle Aufgabe: {{ currentTaskId }}</pre>
      <pre>Erledigte Aufgaben: <br /> {{ completedTasks }}</pre>
    </template>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Button from '@/objects/Button';
import Copy from '@/objects/Copy';
import IntroBanner from '@/components/IntroBanner';
import Tasks from '@/components/Tasks';
import TaskGoals from '@/components/TaskGoals';
import InViewAnimation from '@/components/InViewAnimation';

import { LS_TASK_SCHEDULER_INFO_BANNER } from '@/constants/storage';

import schedules from '@/content/services/TaskScheduler/Schedules';

import mixin from './mixin';

export default {
  name: 'TaskScheduler',
  props: {},
  mixins: [mixin],
  components: {
    Headline,
    Button,
    Copy,
    IntroBanner,
    Tasks,
    TaskGoals,
    InViewAnimation,
  },
  computed: {
    hasOptionalTasks() {
      return this.optionalTasks.filter((ot) => !ot.checked).length > 0;
    },

    nextTask() {
      return schedules[this.currentTaskId].nextTask;
    },
  },
  // mounted() {
  //   // Just testing...
  //   this.$store.dispatch('TASKS_UPDATE_CURRENT_TASK', 'P2-40');
  // },
  data() {
    return {
      testing: !!process.env.VUE_APP_TESTING,
      LS_TASK_SCHEDULER_INFO_BANNER,
      el: 'v-taskScheduler',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
};
</script>
